var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveNowIndicatorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Live_Icon_M_",
    "data-name": "Live Icon (M)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14.738,
    viewBox: "0 0 20 14.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 20,
    height: 14.738,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M190.616,129.986a1.25,1.25,0,1,1,1.25-1.25,1.25,1.25,0,0,1-1.25,1.25",
    transform: "translate(-180.616 -121.367)",
    fill: "#ff4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M279.6,86.871a4.109,4.109,0,0,0,0-5.811",
    transform: "translate(-266.698 -76.597)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M347.937,24.349a8.218,8.218,0,0,0,0-11.622",
    transform: "translate(-332.126 -11.169)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M115.839,86.871a4.109,4.109,0,0,1,0-5.811",
    transform: "translate(-108.745 -76.597)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M20.407,24.349a8.218,8.218,0,0,1,0-11.622",
    transform: "translate(-16.218 -11.169)",
    fill: "none",
    stroke: "#ff4848",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveNowIndicatorMobile);
export default __webpack_public_path__ + "static/media/LiveNowIndicatorMobile.3e1b9c5b7c94847aa7584819db5c7d6e.svg";
export { ForwardRef as ReactComponent };